export const aboutData = {
    title: "About Me",
    description1: "Hi, I'm Marisol. My alias, Algorithmic Programmer, is inspired by my fascination with computer science, mathematics, algorithms, and machine learning.",
    description2: "I'm a graduate student in computer information technology with a 4.0 GPA and a research focus in machine learning. I'm open to new opportunities when I graduate in spring 2025. ",
    image: 2
}
